export const LOADING = 'LOADING';
export const LOADING_CHECKING_CONNECTION = 'LOADING_CHECKING_CONNECTION';
export const ERROR = 'ERROR';
export const TEMPLATE = 'TEMPLATE';
